import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CONSULTATIONS } from "../data/consultations";

gsap.registerPlugin(ScrollTrigger);

const SOLUTIONS = [
  { label: "Growth Engine", href: "/#solutions" },
  { label: "Launch Sprint", href: "/#solutions" },
  { label: "Automate & Scale", href: "/#solutions" },
];

const Footer = () => {
  const wordRef = useRef(null);
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || !wordRef.current) return;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        wordRef.current,
        { yPercent: 30, opacity: 0.2 },
        {
          yPercent: 0,
          opacity: 1,
          ease: "expo.out",
          duration: 1.6,
          scrollTrigger: { trigger: wordRef.current, start: "top 90%" },
        }
      );
    });
    return () => ctx.revert();
  }, []);

  return (
    <footer data-testid="footer-section" className="relative px-6 md:px-12 lg:px-20 pt-24 md:pt-32 pb-10">
      <div className="grid md:grid-cols-4 gap-12 mb-20 md:mb-28">
        <div>
          <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">Navigate</span>
          <ul className="mt-5 space-y-2 text-[#0a0a0b]">
            <li><Link to="/" data-testid="footer-link-home" className="hover:accent-text transition-colors">Home</Link></li>
            <li><Link to="/services" data-testid="footer-link-services" className="hover:accent-text transition-colors">Services</Link></li>
            <li><Link to="/#solutions" data-testid="footer-link-solutions" className="hover:accent-text transition-colors">Solutions</Link></li>
            <li><Link to="/#process" data-testid="footer-link-process" className="hover:accent-text transition-colors">Process</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="hover:accent-text transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">Services</span>
          <ul className="mt-5 space-y-2 text-[#0a0a0b] text-sm">
            {CONSULTATIONS.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/services/${c.slug}`}
                  data-testid={`footer-svc-${c.slug}`}
                  className="hover:accent-text transition-colors"
                >
                  {c.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">Solutions</span>
          <ul className="mt-5 space-y-2 text-[#0a0a0b] text-sm">
            {SOLUTIONS.map((s) => (
              <li key={s.label}>
                <Link
                  to={s.href}
                  data-testid={`footer-sol-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="hover:accent-text transition-colors"
                >
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <span className="text-[10px] tracking-[0.4em] uppercase text-muted-ink">Studio</span>
          <p className="mt-5 text-[#0a0a0b]">Delventure</p>
          <p className="text-muted-ink text-sm mt-1">AI-native digital studio</p>
          <p className="text-muted-ink text-sm mt-4">hello@delventure.com</p>
          <ul className="mt-6 space-y-2 text-[#0a0a0b] text-sm">
            <li><a href="#" className="hover:accent-text transition-colors">LinkedIn</a></li>
            <li><a href="#" className="hover:accent-text transition-colors">Instagram</a></li>
            <li><a href="#" className="hover:accent-text transition-colors">X / Twitter</a></li>
          </ul>
        </div>
      </div>

      <div className="overflow-hidden -mx-6 md:-mx-12 lg:-mx-20">
        <h2
          ref={wordRef}
          data-testid="footer-wordmark"
          className="font-display font-bold leading-[0.85] tracking-tighter select-none accent-text text-center px-2"
          style={{ fontSize: "clamp(3rem, 15.5vw, 18rem)" }}
        >
          DELVENTURE
        </h2>
      </div>

      <div className="mt-8 flex items-center justify-between flex-wrap gap-4 text-xs text-muted-ink">
        <span>© {new Date().getFullYear()} Delventure. All rights reserved.</span>
        <span
          data-testid="footer-tagline"
          className="tracking-[0.2em] uppercase text-right max-w-xl"
        >
          Delventure is a digital marketing, technology, and business consultancy.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
